import React, { useState, useEffect, useMemo } from "react";
import _ from "lodash";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReviewList from "../components/common/reviewComponents/reviewList";
import { locationsSelector, setSelectedThen } from "../../store/slices/location";
import InfoIcon from "@mui/icons-material/Info";
import {
  fetchReviews,
  reviewsSelector,
  fetchSimilarReviews,
  triggerSaveExampleReview,
  triggerDeleteExampleReview,
  triggerDeleteCustomExampleReview,
} from "../../store/slices/reviews";
import { companiesSelector } from '../../store/slices/company'
import { createFilter } from "react-search-input";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  Tab,
  Tabs,
  MenuItem,
  Paper,
  Typography,
  Button,
  Menu,
  IconButton,
  Tooltip,
  Divider,
  Grid,
  Box,
  Stack,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { TopicChip as Chip, TopicChip } from "../components/common/topicChip";
import CustomizeResponse from "../components/common/reviewComponents/customizeResponse";
import moment from "moment";
import { fetchGPTUsageData, logSelector, setInput } from "../../store/slices/logs";
import AppConfig from "../../appConfig";
import {
  useStyles,
  ReviewItem,
} from "../components/common/reviewComponents/reviewUtils";
import Facts from "../components/common/reviewComponents/facts";
import TrainingExampleModal from "../components/common/reviewComponents/trainingExampleModal";
import BrandVoice from "../components/common/brandVoice";
import { defaultGuid } from "../../common/utils";
import Settings from "../components/common/reviewComponents/settings";

const initialCache = {};

const Reviews = ({
  selectedCompany,
  selectedLocation,
  userRoles,
  setSelectedLocation,
  locations,
  brandVoiceData,
  startDate,
  endDate,
}) => {
  const isIRUser = React.useMemo(
    () => userRoles?.indexOf("IRUser") >= 0,
    [userRoles]
  );
  const [text, setText] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedExampleReviews, setSelectedExampleReviews] = useState([]);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElTraining, setAnchorElTraining] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [cache, setCache] = useState(initialCache);
  const [vanillaCache, setVanillaCache] = useState(initialCache);

  const [selectedReviewIds, setSelectedReviewIds] = useState([]);
  const [selectedReviewText, setSelectedReviewText] = useState([]);
  // console.log('selectedReviewText',selectedReviewText)
  const [selectededReview, setSelectedReview] = useState([]);
  const [selectedReviewer, setSelectedReviewer] = useState([]);
  const { reviews, similarReviews } = useSelector(reviewsSelector);
  const { loadingCompany } = useSelector(companiesSelector);
  const { gptUsage, loading } = useSelector(logSelector);
  const { generateResponse } = useSelector(reviewsSelector);
  const {facts}=useSelector(locationsSelector)
  const [customSettings, setCustomsettings] = useState({
    training: true,
    facts: true,
    brandVoice: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState("With Text");
  const [selectedTab, setSelectedTab] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [reviewsPage, setReviewsPage] = useState(1);
  const [noOfPages, setPages] = useState(0);
  const [selectedFacts, setSelectedFacts] = useState([]);
  // const [selectedThen, setSelectedThen] = useState({});
  const [openTrainingExampleModal, setOpenTrainingExampleModal] =
    useState(false);
  const [singleSelectedExample, setSingleSelectedExample] = useState({});
  const [trainingMode, setTrainingMode] = useState("Add");
  const [openWarning, setWarning] = useState(false);
  const [selectedBrandVoiceContainer, setSelectedBrandVoiceContainer] =
    useState(null);

  const { selectedThen } = useSelector(locationsSelector);

  // useEffect(() => {
  //   dispatch(fetchBrandVoice(defaultGuid))
  // }, [])
  useEffect(() => {
    if (selectedBrandVoiceContainer) {
      setCustomsettings((prevSettings) => ({
        ...prevSettings,
        brandVoice: true,
      }));
    } else {
      setCustomsettings((prevSettings) => ({
        ...prevSettings,
        brandVoice: false,
      }));
      setSelectedBrandVoiceContainer(null);
    }
  }, [selectedBrandVoiceContainer]);

  useEffect(
    () => setSelectedReviewIds([]),
    [selectedLocation, selectedCompany]
  );
  const relevanceFactsList=useMemo(()=>{
    const tempData=similarReviews?.agents?.relevanceFacts
    if(!tempData){
      return setSelectedFacts([])
    }
    if(!JSON.parse(tempData)){
      return setSelectedFacts([])
    }
      let factsArr=JSON.parse(tempData)?.RelevanceFacts
     factsArr = factsArr?.matched_fact_catalog_items? factsArr?.matched_fact_catalog_items : factsArr;
      const tt= _.filter(_.map(facts,it=>{const found=_.find(factsArr,a=> _.toLower(it.factId)=== _.toLower(a.fact_id) || _.toLower(it?.fact)===_.toLower(a.Fact))
        return found
      }), it=> it)
       setSelectedFacts(tt)
  },[facts,similarReviews])
  const similarReviewsMemo = useMemo(() => {
    const tempReviews = _.orderBy(
      similarReviews?.reviews,
      "similarity",
      "desc"
    );
    return _.size(selectedReviewIds) > 0 ? tempReviews : [];
  }, [similarReviews?.reviews, selectedReviewIds]);
  const exampleReviewsMemo = useMemo(() => {
    const tempReviews = _.orderBy(
      _.filter(similarReviews?.exampleReviews, (it) => it.responseText),
      "similarity",
      "desc"
    );
    return _.size(selectedReviewIds) > 0 ? tempReviews : [];
  }, [similarReviews?.exampleReviews, selectedReviewIds]);
  const handleDelete = () => {
    const deleteExampleReview = singleSelectedExample?.exampleReviewId;
    if (singleSelectedExample?.reviewId) {
      dispatch(triggerDeleteExampleReview(singleSelectedExample?.reviewId));
    } else {
      dispatch(
        triggerDeleteCustomExampleReview(
          deleteExampleReview,
          selectedReviewIds[0]
        )
      );
    }
    handleCloseWarning();
    handleClose();
  };
  const handleOpenTrainingExampleModal = (event) => {
    setOpenTrainingExampleModal(true);
  };
  const handleCloseWarning = () => {
    setWarning(false);
    setSingleSelectedExample({});
  };
  const handleCloseTrainingExampleModal = () => {
    setOpenTrainingExampleModal(false);
    setSingleSelectedExample({});
    setTrainingMode("Add");
  };

  useEffect(() => {
    setText(generateResponse);
  }, [generateResponse]);

  useEffect(() => {
    setText("");
  }, [selectedReviewIds]);
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const getSortedReviews = () => {
    if (reviews && reviews.length > 0) {
      return _.sortBy(_.cloneDeep(reviews), ["reviewDateTime"], ["desc"]);
    } else {
      return [];
    }
  };

  const sortedReviews = React.useMemo(
    () => getSortedReviews(),
    [reviews, startDate, endDate]
  );

  const handleSelectedExampleReviews = (review) => {
    if (
      _.find(
        selectedExampleReviews,
        (it) => it.exampleReviewId === review.exampleReviewId
      )
    ) {
      setSelectedExampleReviews((prev) =>
        _.filter(prev, (a) => a.exampleReviewId !== review.exampleReviewId)
      );
    } else {
      setSelectedExampleReviews((prev) => [...prev, review]);
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickTraining = (event) => {
    setAnchorElTraining(event.currentTarget);
  };

  const handleCloseTraining = () => {
    setAnchorElTraining(null);
    setTrainingMode("Add");
    setSingleSelectedExample({});
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setSelectedReviewIds([]);
    handleClose();
  };

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
  };
  useEffect(() => {
    if(!loadingCompany && selectedReviewIds?.[0]){

      dispatch(fetchSimilarReviews(selectedReviewIds?.[0]));
    }
    
  }, [selectedReviewIds, loadingCompany])
  const handleCheckboxChange = (reviewId, reviewText, author, review) => {
    if (selectedReviewIds.includes(reviewId)) {
      setSelectedReviewIds(selectedReviewIds.filter((id) => id !== reviewId));
      setSelectedReviewText([]);
      setSelectedReviewer("");
      // setSelectedReview();
    } else {
      setSelectedReview([review]);
      setSelectedReviewIds([reviewId]);
      setSelectedReviewText(reviewText??"");
      setSelectedReviewer(author);
    }
    setSelectedExampleReviews([]);
    //dispatch(fetchSimilarReviews(reviewId));
  };

  // useEffect(() => {
  //   if (
  //     selectedCompany !== null &&
  //     selectedCompany !== undefined &&
  //     selectedCompany !== "" &&
  //     startDate !== null &&
  //     startDate !== undefined &&
  //     startDate !== "" &&
  //     endDate !== null &&
  //     endDate !== undefined &&
  //     endDate !== ""
  //   ) {
  //     dispatch(fetchReviews(startDate, endDate, selectedCompany));
  //   }
  // }, [selectedCompany, startDate, endDate]);
  // console.log(startDate);

  useEffect(() => {
    setSearchTerm("");
    setSelectedExampleReviews([]);
  }, [selectedLocation, startDate, endDate, sortedReviews]);

  useEffect(() => {
    if (selectedCompany) {
      dispatch(setInput({ ["PromptType"]: "Response" }))
    }
  }, [selectedCompany]);
  const bindTopics = (review) => {
    return _.map(review?.topics, (a, index) =>
      a.topic !== "" ? (
        <Chip
          key={index}
          sx={{ ml: 2 }}
          color={a?.sentiment == "Positive" ? "success" : "error"}
          label={a?.topic}
        />
      ) : (
        ""
      )
    );
  };

  const bindfinalData = (data) => {
    return _.map(_.cloneDeep(data), (it, index) => {
      const topicData = _.map(it?.topicData?.split("|"), (ob) => {
        const [topic, sentiment] = ob?.split(":");
        return { topic, sentiment };
      });
      it["topics"] = topicData;
      it["topicElement"] = bindTopics(it);
      return it;
    });
  };
  const KEYS_TO_FILTERS = ["responseText", "reviewText", "author"];
  const prepareFinalData = (data) => {
    let cloneData = bindfinalData(data);
    let filterData = cloneData;
    switch (selectedOption) {
      case "With Text":
        filterData = _.filter(filterData, (a) => a.reviewText != null);
        break;
      case "Without Text":
        filterData = _.filter(filterData, (a) => a.reviewText == null);
        break;
      case "With Response":
        filterData = _.filter(filterData, (a) => a.responseText != null);
        break;
      case "Without Response":
        filterData = _.filter(filterData, (a) => a.responseText == null);
        break;
    }
    if (selectedLocation != "all") {
      filterData = _.filter(
        filterData,
        (a) => a.locationId == selectedLocation
      );
    }
    if (searchTerm) {
      filterData = filterData.filter(createFilter(searchTerm, KEYS_TO_FILTERS));
    }

    return _.orderBy(filterData, "reviewDateTime", "desc");
  };

  const finalData = React.useMemo(
    () => prepareFinalData(sortedReviews),
    [sortedReviews, selectedOption, selectedLocation, searchTerm]
  );
  //======Pagination======//
  const itemsPerPage = useMemo(() => 50, []);

  const handlePaginationChange = (event, value) => {
    setReviewsPage(value);
  };
  const cardTableData = React.useMemo(() => {
    return finalData.slice(
      (reviewsPage - 1) * itemsPerPage,
      reviewsPage * itemsPerPage
    );
  }, [finalData, itemsPerPage, reviewsPage]);

  const startIndexPagination = React.useMemo(() => {
    return (
      finalData.findIndex(
        (item) => item.reviewId === cardTableData[0]?.reviewId
      ) + 1
    );
  }, [reviewsPage, cardTableData, finalData]);
  const endIndexPagination = React.useMemo(() => {
    return (
      finalData.findIndex(
        (item) =>
          item.reviewId === cardTableData[cardTableData.length - 1]?.reviewId
      ) + 1
    );
  }, [reviewsPage, cardTableData, finalData]);
  useEffect(() => {
    setPages(Math.ceil(finalData?.length / itemsPerPage));
  }, [finalData]);

  //===Pagination end====//
  return (
    <div style={{ paddingTop: '14px', height: 'calc(100vh - 50px)' }}>
      <Grid container columns={5}>
        <Grid
          item
          xs={2}
          sx={{
            borderRight: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <ReviewList
            data={sortedReviews}
            startDate={startDate}
            endDate={endDate}
            selectedCompany={selectedCompany}
            selectedLocation={selectedLocation}
            singleSelectFunction={handleCheckboxChange}
            reviewHeight={125}
          />
          {/* </div> */}
        </Grid>

        <Grid item xs={3} sx={{ pl: 2}}>
          <div>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              sx={{ borderBottom: "1px solid #888", pt: 0.5 }}
            >
              <Tab
                value={0}
                sx={{ textTransform: "none" }}
                label="Response"
              />
             
              <Tab value={2} sx={{ textTransform: "none" }} label="Facts" />

              <Tab value={4} sx={{ textTransform: "none" }} label="Voices" />
             
            
            <Tab
                value={5}
                sx={{ textTransform: "none" }}
                label="Customizations"
              />
            </Tabs>

            <div>
              {selectedTab === 0 && (
                <div>
                  <div>
                    <CustomizeResponse
                      selectedCompany={selectedCompany}
                      selectededReview={selectededReview}
                      selectedReviewText={selectedReviewText}
                      selectedReviewer={selectedReviewer}
                      selectedReviewIds={selectedReviewIds}
                      setRefresh={setRefresh}
                      refresh={refresh}
                      gptUsage={gptUsage}
                      selectedId={selectedId}
                      setSelectedId={setSelectedId}
                      setCache={setCache}
                      setVanillaCache={setVanillaCache}
                      text={text}
                      setText={setText}
                      selectedExampleReviews={selectedExampleReviews}
                      selectedFacts={selectedFacts}
                      selectedThen={selectedThen}
                      setSelectedThen={setSelectedThen}
                      cache={cache}
                      vanillaCache={vanillaCache}
                      customSettings={customSettings}
                      setCustomsettings={setCustomsettings}
                      isReviews={true}
                      topicType={1}
                      selectedBrandVoiceContainer={selectedBrandVoiceContainer}
                      setSelectedBrandVoiceContainer={
                        setSelectedBrandVoiceContainer
                      }
                      boxHeight={125}
                    />
                  </div>
                </div>
              )}
              {selectedTab === 3 && (
                <div className={classes.reviewContainer2}>
                  <div className={classes.innerContainer}>
                    {similarReviewsMemo?.map((review, index) => (
                      <Paper key={index} className={classes.reviewBox}>
                        <div>
                          <div className={classes.reviewHeader}>
                            <Typography variant="body2">
                              {review?.author}
                            </Typography>
                            <Typography variant="body2">
                              {new Date(
                                review?.reviewDateTime
                              ).toLocaleDateString()}
                            </Typography>
                          </div>
                          <Typography
                            className={classes.rating}
                            variant="subtitle2"
                          >
                            (
                            <span style={{ paddingTop: "1px" }}>
                              {review?.rating}
                            </span>
                            <StarOutlineIcon
                              sx={{
                                fontSize: "0.875rem",
                                mb: "-2px !important",
                              }}
                            />
                            ){" "}
                            {review?.topicData
                              ?.split(",")
                              .map((topicSentimentPair, i) => {
                                const [topic, sentiment] =
                                  topicSentimentPair?.split(":");
                                if (topic && sentiment) {
                                  return (
                                    <TopicChip
                                      sx={{ ml: 2 }}
                                      className={
                                        sentiment === "Positive"
                                          ? "positive-chip"
                                          : "negative-chip"
                                      }
                                      key={index}
                                      //  color={a?.sentiment == "Positive" ? "success" : "error"}
                                      label={topic}
                                    />
                                  );
                                } else {
                                  return null;
                                }
                              })}
                          </Typography>
                          <Typography
                            className={classes.reviewText}
                            variant="body1"
                          >
                            {review?.reviewText || "No review text available"}
                          </Typography>
                        </div>
                        <ReviewItem key={index} review={review} noReviewText />
                      </Paper>
                    ))}
                  </div>
                </div>
              )}
              {selectedTab === 1 && (
                <>
                  {/* <Stack direction="row" justifyContent={"flex-end"}>
                    <span>
                      <Button
                        variant="outlined"
                        sx={{ textTransform: "none", mt: 2 }}
                        color="primary"
                        onClick={() => {
                          handleOpenTrainingExampleModal();
                        }}
                      >
                        Add Training Example
                      </Button>
                    </span>
                  </Stack> */}
                  <div className={classes.reviewContainer2}>
                    <div className={classes.innerContainer}>
                      {exampleReviewsMemo?.map((review, index) => (
                        <Paper key={index} className={classes.reviewBox}>
                          <div>
                            <div className={classes.reviewHeader}>
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems={"center"}
                              >
                                <Checkbox
                                  size="small"
                                  checked={Boolean(
                                    _.find(
                                      selectedExampleReviews,
                                      (it) =>
                                        it.exampleReviewId ===
                                        review.exampleReviewId
                                    )
                                  )}
                                  onChange={() =>
                                    handleSelectedExampleReviews(review)
                                  }
                                />
                                <Typography variant="body2">
                                  {review?.reviewId
                                    ? review?.author
                                    : "Custom Training Review"}
                                </Typography>
                              </Stack>
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{ mb: "-4px !important" }}
                                >
                                  {review?.reviewId &&
                                    new Date(
                                      review?.reviewDateTime
                                    ).toLocaleDateString()}
                                </Typography>
                                {review?.similarity && (
                                  <Tooltip title={review?.similarity}>
                                    <span>
                                      <IconButton size="small">
                                        <InfoIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                )}
                                {
                                  <IconButton
                                    onClick={(e) => {
                                      setSingleSelectedExample(review);
                                      setTrainingMode("Edit");
                                      handleClickTraining(e);
                                    }}
                                    size="small"
                                  >
                                    <MoreVertIcon fontSize="small" />
                                  </IconButton>
                                }
                              </Stack>
                            </div>
                            {review?.reviewId && (
                              <Typography
                                className={classes.rating}
                                variant="subtitle2"
                              >
                                (
                                <span style={{ paddingTop: "1px" }}>
                                  {review?.rating}
                                </span>
                                <StarOutlineIcon
                                  sx={{
                                    fontSize: "0.875rem",
                                    mb: "-2px !important",
                                  }}
                                />
                                ){" "}
                                {review?.topicData
                                  ?.split(",")
                                  .map((topicSentimentPair, i) => {
                                    const [topic, sentiment] =
                                      topicSentimentPair?.split(":");
                                    if (topic && sentiment) {
                                      return (
                                        <TopicChip
                                          sx={{ ml: 2 }}
                                          className={
                                            sentiment === "Positive"
                                              ? "positive-chip"
                                              : "negative-chip"
                                          }
                                          key={index}
                                          //  color={a?.sentiment == "Positive" ? "success" : "error"}
                                          label={topic}
                                        />
                                      );
                                    } else {
                                      return null;
                                    }
                                  })}
                              </Typography>
                            )}

                            <Typography
                              className={classes.reviewText}
                              variant="body1"
                            >
                              {review?.reviewText || "No review text available"}
                            </Typography>
                          </div>
                          <ReviewItem
                            key={index}
                            review={review}
                            noReviewText
                          />
                        </Paper>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {selectedTab===5&&(<Settings companyId={selectedCompany}/>)}
              {selectedTab === 2 && (
                <Facts
                  selectededReview={selectededReview}
                  data={facts}
                  classes={classes}
                  selectedLocation={selectedLocation}
                  selectedCompany={selectedCompany}
                  reviewId={
                    selectedReviewIds.length > 0 ? selectedReviewIds : null
                  }
                  selectedFacts={selectedFacts}
                  setSelectedFacts={setSelectedFacts}
                  selectedThen={selectedThen}
                  setSelectedThen={setSelectedThen}
                />
              )}
              {selectedTab === 4 && (
                // <div className={classes.reviewContainer2}>
                //   <div className={classes.innerContainer}>
                <BrandVoice
                  brandVoiceData={brandVoiceData}
                  companyId={selectedCompany}
                  classes={classes}
                  selectedBrandVoiceContainer={selectedBrandVoiceContainer}
                  selectedLocation={selectedLocation}
                  setSelectedBrandVoiceContainer={
                    setSelectedBrandVoiceContainer
                  }
                />
                //   </div>
                // </div>
              )}
            </div>
          </div>
        </Grid>
      </Grid>

      <Menu
        open={Boolean(anchorElTraining)}
        anchorEl={anchorElTraining}
        onClose={handleCloseTraining}
        aria-label="Training Example Menu"
      >
        <MenuItem
          disabled={singleSelectedExample?.reviewId}
          onClick={() => {
            handleOpenTrainingExampleModal();
            setAnchorElTraining(null);
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setWarning(true);
            setAnchorElTraining(null);
          }}
        >
          Delete
        </MenuItem>
      </Menu>
      {openTrainingExampleModal && (
        <TrainingExampleModal
          selectedCompany={selectedCompany}
          open={openTrainingExampleModal}
          close={handleCloseTrainingExampleModal}
          selectedReviewId={selectedReviewIds[0]}
          params={{
            text: singleSelectedExample?.reviewText,
            response: singleSelectedExample?.responseText,
            ...singleSelectedExample
          }}
          mode={trainingMode}
        />
      )}
      {openWarning && (
        <Dialog open={openWarning}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <Divider />
          <DialogContent>
            Are you sure you want to delete this Training Example Review?
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={handleDelete}
              variant="contained"
              size="small"
              color="error"
            >
              Delete
            </Button>
            <Button
              onClick={handleCloseWarning}
              size="small"
              variant="outlined"
              color="primary"
              sx={{ ml: 2 }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default Reviews;
